module.exports = __webpack_public_path__ + "static/img/1.33ed84c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/4/1.png
// module id = N+ae
// module chunks = 0